<template>
  <Card class="card market px-4 px-sm-7 py-6">
    <div class="card-title mb-10"><v-img v-for="(item, index) in dealIcon" :key="index" class="icon mb-4 float-left" alt="icon" :src="item.src" width="20" ></v-img>云彩公共超市</div>
    <div class="deal-messages mb-12">
      <div class="item" v-for="(item, index) in dealMessages" :key="index">{{item.text}}</div>
    </div>
    <v-btn class="btn-detail px-7" rounded>进入</v-btn>
  </Card>
</template>

<script>
import Card from '@/components/UI/Card'
import MarketIcon from '@/assets/icons/yuncaichaos.svg'
export default {
  name: 'Market',
  components: {
    Card
  },
  data () {
    return {
      dealIcon: [{
        src: MarketIcon
      }],
      dealMessages: [{
        text: '福建区累计交易：11.22亿'
      }]
    }
  }
}
</script>

<style lang="scss" scoped>
.market {
  .v-image {
    margin-right: 10px;
    margin-top: 2px;
  }
  .btn-detail {
    background-color: $main-color !important;
    color: #FFF;
    height: 38px;
  }
  .deal-messages {
    .item {
      font-size: 18px;
      font-weight: 500;
      color: #d81b2b;
    }
  }
}
</style>
